import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { EntityMemberJSON } from "_shared/entity-members/entity-member-schema";
import { FeeScheduleCategoryType } from "_shared/fee-schedules/categories/types/fee-schedule-category-type";

export default class MarketplaceFeeScheduleCategoryAPIRequest {
  public name: string;
  public description?: string;
  public type: FeeScheduleCategoryType;
  public feeRate?: number;
  public feeCurrency?: string;
  public feeUnit?: string;
  public teamMember?: EntityMemberJSON | null;

  public constructor(feeCategory: FeeScheduleCategory) {
    const name = feeCategory.name.value;
    if (!name) {
      throw new Error("Fee schedule category name is required");
    }

    this.name = name;
    this.description = feeCategory.description?.value ?? "";
    this.type = feeCategory.type;
    this.feeRate = feeCategory.fee?.rate.amount;
    this.feeCurrency = feeCategory.fee?.rate.currency;
    this.feeUnit = feeCategory.fee?.unit ?? undefined;
    this.teamMember = feeCategory.teamMember?.toJSON() ?? null;
  }
}
